import { AppState } from "../../../redux/reducers/rootReducer";
import { IAuditDoc } from "../doc/IAuditDoc";

export enum AuditAction {
  CREATE = "create",
  DELETE = "delete",
  UPDATE = "update",
}

/**
 *
 * @param user user realiza la acción
 * @param action create, delete , update
 */
export const setAuditAction = (user: any, action: AuditAction) => {
  let dataAudit: IAuditDoc = {
    id: "",
    createdAt: new Date().toISOString(), // Add a timestamp
    action: action,
    user: user?.id,
    idEntity: user.idEntity,
  };

  return dataAudit; // Retorna el objeto auditado
};

